(function () {
  "use strict";

  function rng(seed) {
    return function () {
      seed = (seed * 1664525 + 1013904223) % 4294967296;
      return seed / 4294967296;
    };
  }

  /* ---------- one palm frond, drawn as a spine with leaflets ---------- */
  function frond(c, x, y, len, angle, width, fill, rand) {
    var leaflets = 14 + Math.floor(rand() * 8);
    c.save();
    c.translate(x, y);
    c.rotate(angle);
    c.fillStyle = fill;

    // spine
    c.beginPath();
    c.moveTo(0, -width * 0.06);
    c.quadraticCurveTo(len * 0.5, -width * 0.10, len, 0);
    c.quadraticCurveTo(len * 0.5, width * 0.10, 0, width * 0.06);
    c.closePath();
    c.fill();

    for (var i = 0; i < leaflets; i++) {
      var t = (i + 1) / (leaflets + 1);
      var px = len * t;
      var curve = Math.sin(t * Math.PI);          // fat in the middle
      var ll = width * curve * (0.85 + rand() * 0.3);
      var droop = 0.55 + t * 0.5;

      [-1, 1].forEach(function (side) {
        c.beginPath();
        c.moveTo(px, 0);
        c.quadraticCurveTo(
          px + ll * 0.45, side * ll * droop * 0.55,
          px + ll * 0.25, side * ll * droop
        );
        c.quadraticCurveTo(px + ll * 0.02, side * ll * droop * 0.45, px, 0);
        c.closePath();
        c.fill();
      });
    }
    c.restore();
  }

  /* ---------- a teal lightning bolt ---------- */
  function bolt(c, x, y, height, stroke, glow, rand) {
    var segs = 5 + Math.floor(rand() * 3);
    var pts = [[x, y]];
    for (var i = 1; i <= segs; i++) {
      var t = i / segs;
      pts.push([x + (rand() - 0.5) * height * 0.30, y + height * t]);
    }
    c.save();
    c.lineCap = "round";
    c.lineJoin = "round";

    c.strokeStyle = glow;
    c.lineWidth = 9;
    c.globalAlpha = 0.30;
    c.beginPath();
    pts.forEach(function (p, i) { i ? c.lineTo(p[0], p[1]) : c.moveTo(p[0], p[1]); });
    c.stroke();

    c.globalAlpha = 1;
    c.strokeStyle = stroke;
    c.lineWidth = 2.4;
    c.beginPath();
    pts.forEach(function (p, i) { i ? c.lineTo(p[0], p[1]) : c.moveTo(p[0], p[1]); });
    c.stroke();
    c.restore();
  }

  function jungle(canvas, o) {
    if (!canvas) return;
    o = o || {};
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var r = canvas.getBoundingClientRect();
    var w = Math.max(r.width, 320), h = Math.max(r.height, 200);
    canvas.width = w * dpr; canvas.height = h * dpr;
    var c = canvas.getContext("2d");
    if (!c) return;
    c.scale(dpr, dpr);

    if (o.bg) { c.fillStyle = o.bg; c.fillRect(0, 0, w, h); }
    else { c.clearRect(0, 0, w, h); }

    var rand = rng(o.seed || 20260907);
    var layers = o.layers || [
      { fill: "rgba(15,163,173,0.13)", n: 5, len: 0.55, width: 62 },
      { fill: "rgba(7,102,110,0.13)",  n: 4, len: 0.42, width: 50 },
      { fill: "rgba(18,24,26,0.07)",   n: 4, len: 0.34, width: 40 }
    ];

    layers.forEach(function (L) {
      for (var i = 0; i < L.n; i++) {
        var fromLeft = rand() < 0.5;
        var x = fromLeft ? -20 : w + 20;
        var y = h * (rand() * 1.15 - 0.08);
        var base = fromLeft ? 0 : Math.PI;
        var a = base + (rand() - 0.5) * 1.5;
        frond(c, x, y, w * L.len * (0.7 + rand() * 0.6), a, L.width, L.fill, rand);
      }
    });

    var bolts = o.bolts == null ? 3 : o.bolts;
    for (var b = 0; b < bolts; b++) {
      bolt(c,
        w * (0.12 + rand() * 0.78),
        -h * 0.05,
        h * (0.45 + rand() * 0.5),
        o.boltStroke || "rgba(15,163,173,0.55)",
        o.boltGlow  || "rgba(63,208,216,0.55)",
        rand);
    }
  }

  function paintAll() {
    jungle(document.querySelector("[data-jungle-banner]"), { seed: 4471, bolts: 3 });
  }

  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  ready(function () {
    paintAll();

    var t;
    window.addEventListener("resize", function () {
      clearTimeout(t);
      t = setTimeout(paintAll, 220);
    });

    /* variant picker */
    var form = document.querySelector("[data-product-form]");
    if (form) {
      var select = form.querySelector("select[name='id']");
      var priceEl = document.querySelector("[data-pdp-price]");
      var submit = form.querySelector("[data-add]");
      form.addEventListener("click", function (e) {
        var b = e.target.closest(".szbtn");
        if (!b || b.disabled) return;
        e.preventDefault();
        Array.prototype.forEach.call(form.querySelectorAll(".szbtn"), function (x) {
          x.setAttribute("aria-pressed", String(x === b));
        });
        if (select) select.value = b.getAttribute("data-variant-id");
        if (priceEl && b.getAttribute("data-price")) priceEl.textContent = b.getAttribute("data-price");
        if (submit) {
          var avail = b.getAttribute("data-available") === "true";
          submit.disabled = !avail;
          submit.textContent = avail ? "Add to cart" : "Sold out";
        }
      });
    }

    /* PDP thumbnails */
    document.addEventListener("click", function (e) {
      var th = e.target.closest("[data-thumb]");
      if (!th) return;
      var main = document.getElementById("pdpMain");
      if (main) main.src = th.getAttribute("data-full");
    });

    /* cart quantity */
    var cartForm = document.querySelector("[data-cart-form]");
    if (cartForm) {
      cartForm.addEventListener("change", function (e) {
        if (e.target.classList.contains("qty")) cartForm.submit();
      });
    }
  });
})();
